import * as React from "react";
import { IconProps } from "../types";

const Sparkles4FillIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M2.342 4.97389L3.605 5.39489L4.026 6.65789C4.094 6.86189 4.286 6.99989 4.501 6.99989C4.716 6.99989 4.907 6.86189 4.976 6.65789L5.397 5.39489L6.66 4.97389C6.864 4.90589 7.002 4.71489 7.002 4.49989C7.002 4.28489 6.864 4.09389 6.66 4.02589L5.397 3.60489L4.976 2.34189C4.839 1.93389 4.164 1.93389 4.027 2.34189L3.606 3.60489L2.343 4.02589C2.139 4.09389 2.001 4.28489 2.001 4.49989C2.001 4.71489 2.138 4.90589 2.342 4.97389Z"
          fill={color}
        />
        <path
          d="M15.658 13.0259L14.395 12.6049L13.974 11.3419C13.837 10.9339 13.162 10.9339 13.025 11.3419L12.604 12.6049L11.341 13.0259C11.137 13.0939 10.999 13.2849 10.999 13.4999C10.999 13.7149 11.137 13.9059 11.341 13.9739L12.604 14.3949L13.025 15.6579C13.093 15.8619 13.285 15.9999 13.5 15.9999C13.715 15.9999 13.906 15.8619 13.975 15.6579L14.396 14.3949L15.659 13.9739C15.863 13.9059 16.001 13.7149 16.001 13.4999C16.001 13.2849 15.863 13.0939 15.659 13.0259H15.658Z"
          fill={color}
        />
        <path
          d="M9.525 11.3029L7.499 10.5009L6.697 8.47392C6.47 7.90192 5.529 7.90192 5.302 8.47392L4.5 10.5009L2.474 11.3029C2.188 11.4159 1.999 11.6929 1.999 11.9999C1.999 12.3069 2.187 12.5839 2.474 12.6969L4.5 13.4989L5.302 15.5259C5.415 15.8119 5.692 15.9999 5.999 15.9999C6.306 15.9999 6.583 15.8119 6.696 15.5259L7.498 13.4989L9.524 12.6969C9.81 12.5839 9.999 12.3069 9.999 11.9999C9.999 11.6929 9.812 11.4159 9.525 11.3029Z"
          fill={color}
        />
        <path
          d="M15.525 5.30292L13.499 4.50092L12.697 2.47392C12.47 1.90192 11.529 1.90192 11.302 2.47392L10.5 4.50092L8.474 5.30292C8.188 5.41592 7.999 5.69292 7.999 5.99992C7.999 6.30692 8.187 6.58392 8.474 6.69692L10.5 7.49892L11.302 9.52592C11.415 9.81192 11.692 9.99992 11.999 9.99992C12.306 9.99992 12.583 9.81192 12.696 9.52592L13.498 7.49892L15.524 6.69692C15.81 6.58392 15.999 6.30692 15.999 5.99992C15.999 5.69292 15.812 5.41592 15.525 5.30292Z"
          fill={color}
        />
      </svg>
    );
  },
);

export default Sparkles4FillIcon;
